/**
 * @fileoverview Domain Sabitleri
 *
 * MCP araclari, filtre anahtarlari, URL kaliplari ve
 * diger domain-spesifik sabitler.
 *
 * @module utils/constants/domain
 */

// ==================== MCP Tool Names ====================

/**
 * MCP tool adi sabitleri.
 * Tum tool cagrilarinda bu sabitler kullanilmalidir.
 *
 * @constant {Object}
 */
export const TOOL_NAMES = {
  SEARCH_LISTINGS: 'emlakjet.search_listings',
  GET_LISTING_DETAIL: 'emlakjet.get_listing_detail',
  GET_REGION_PRICE: 'emlakjet.get_region_price_info',
  SEARCH_PROJECTS: 'emlakjet.search_projects_by_company',
  MAP_SEARCH: 'emlakjet.map_search',
};

// ==================== Response Kinds ====================

/**
 * Tool yanitlarinin tur sabitleri.
 * structuredContent.kind alaninda kullanilir.
 *
 * @constant {Object}
 */
export const RESPONSE_KINDS = {
  LISTINGS: 'listings',
  LISTING_DETAIL: 'listing_detail',
  REGION_PRICE: 'region_price',
  PROJECTS: 'projects',
};

// ==================== Filter Keys ====================

/**
 * Emlakjet filtre anahtar sabitleri.
 * URL filtre parametrelerinde kullanilir.
 *
 * @constant {Object}
 */
export const FILTER_KEYS = {
  ROOM_COUNT: 'oda-sayisi',
  PRICE_MIN: 'fiyat-min',
  PRICE_MAX: 'fiyat-max',
  AREA_MIN: 'metrekare-min',
  AREA_MAX: 'metrekare-max',
  BUILDING_AGE: 'bina-yasi',
  FLOOR_MIN: 'min-bulundugu-kat',
  FLOOR_MAX: 'max-bulundugu-kat',
  FEATURES: 'ozellikler',
};

// ==================== Sort Orders ====================

/**
 * Siralama secenekleri sabitleri.
 * Arama sonuclarinin siralamasinda kullanilir.
 *
 * @constant {Object}
 */
export const SORT_ORDERS = {
  RELEVANCE: 'relevance',
  PRICE_ASC: 'price_asc',
  PRICE_DESC: 'price_desc',
  DATE_DESC: 'date_desc',
  AREA_DESC: 'area_desc',
};

// ==================== URL Patterns ====================

/**
 * URL kalip sabitleri.
 * Navigasyon ve URL olusturmada kullanilir.
 *
 * @constant {Object}
 */
export const URL_PATTERNS = {
  DETAIL_PREFIX: '/detail/',
  HOME: '/',
  EMLAKJET_BASE: 'https://www.emlakjet.com',
  EMLAKJET_LISTING: 'https://www.emlakjet.com/ilan/',
};

// ==================== Error Actions ====================

/**
 * Hata kurtarma aksiyon sabitleri.
 * ErrorRecovery bileseninde kullanilir.
 *
 * @constant {Object}
 */
export const ERROR_ACTIONS = {
  RETRY: 'retry',
  REMOVE_FILTERS: 'remove-filters',
  EXPAND_DISTRICT: 'expand-district',
  EXPAND_CITY: 'expand-city',
};

// ==================== Quick Info Keys ====================

/**
 * Ilan detayindaki hizli bilgi anahtar sabitleri.
 * quickInfos dizisinde arama yaparken kullanilir.
 *
 * @constant {Object}
 */
export const QUICK_INFO_KEYS = {
  BUILDING_AGE: 'building-age',
  HEATING: 'heating',
  DUES: 'dues',
  BATHROOM_COUNT: 'bathroom-count',
  BALCONY: 'balcony',
  BUILDING_TYPE: 'building-type',
  FRONT: 'front',
  FURNISHED: 'furnished',
  DEED_STATUS: 'deed-status',
  USAGE_STATUS: 'usage-status',
  CREDIT_ELIGIBLE: 'credit-eligible',
};
